module.exports = __webpack_public_path__ + "static/media/parsa-radfar.5c2d7f2a.jpg";